export default {
    // 时间戳转化成时间  2018/4/18 下午3:10:41
    time(timestamp) {
        return timestamp ? new Date(timestamp).toLocaleString() : ''
    },

    // 数据字典
    formatLookup(val, lookup) {
        let lookupList = JSON.parse(sessionStorage.getItem('lookupList'))
        let itemArr = []
        let result = ''
        itemArr = lookupList.find(item => item.key === lookup).lookupValues
        result = (itemArr.find(item => item.value === val) || {}).label
        return result
    }
}



// WEBPACK FOOTER //
// ./src/filters/index.js